export default "__VITE_ASSET__B42g5diT__"